import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientDetailMeetingView のスタイル
 */
export const hotlineClientDetailMeetingViewStyle = tv({
    slots: {
        base: ['flex flex-col gap-16', 'px-16 md:px-0'],
        noDataContent: [
            textStyle({ color: 'base', size: 'sm' }),
            'flex items-center justify-center',
            'py-[70px] px-16',
        ],
    },
});
